module.exports = __webpack_public_path__ + "officialStatic/img/new30.f8d9533.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/news/new30.jpg
// module id = fZ3F
// module chunks = 0